import * as logger from 'loglevel';
import axiosWrapper from '../../helpers/axiosWrapper';
import { NO_DURATION_DEFINED } from '../../helpers/axiosWrapper/cache';

/**
 * Retrieve airlines from the airports Endpoint
 */
const getAirlines = (
  prePopulationAirlines,
  selectedOrigin,
  selectedDestination,
  integrationSettings,
  meta,
  pageContext
) => {
  const sources = prePopulationAirlines === undefined ? [] : prePopulationAirlines.sources;
  return new Promise((resolve, reject) => {
    if (!integrationSettings) {
      const MESSAGE = `INTEGRATION__AIRLINES: **integrationSettings** not especified.`;
      logger.error(MESSAGE);
      reject(MESSAGE);
    }
    const { v3AvaliableAirlinesByRoute: airlinesApiSettings } = integrationSettings;
    const { cache = false, cacheDuration = NO_DURATION_DEFINED } = airlinesApiSettings;

    if (
      !airlinesApiSettings ||
      !airlinesApiSettings.method ||
      !airlinesApiSettings.endPoint ||
      !airlinesApiSettings.headers
    ) {
      const MESSAGE = `INTEGRATION__AIRLINES: **integrationSettings.airlinesApiSettings** configuration issues.`;
      logger.error(MESSAGE);
      reject(MESSAGE);
    }
    if (
      selectedOrigin &&
      selectedOrigin !== '' &&
      selectedDestination &&
      selectedDestination !== ''
    ) {
      axiosWrapper(
        {
          method: airlinesApiSettings.method,
          url: `${airlinesApiSettings.endPoint}`,
          headers: { ...airlinesApiSettings.headers },
          data: {
            routes: [selectedOrigin + '' + selectedDestination],
            sources: sources
          }
        },
        {
          resource: 'INTEGRATION__AIRLINES',
          meta,
          integrationSettings,
          pageContext,
          cache,
          cacheDuration
        }
      )
        .then((response) => {
          logger.info('INTEGRATION__AIRLINES: Successful request', response.data);
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    }
  });
};

export { getAirlines };
